import type { UseQueryOptions } from 'react-query';
import { newsletterTypesApiKeys } from '@hooks/api/lists/useNewsletterTypesApi';
import { useNewsletterTypesApi } from '@hooks/api/lists/useNewsletterTypesApi';
import { useGetApi } from '@hooks/api/useGetApi';
import sortBy from 'lodash/sortBy';

import type { NewsletterTypesResult } from '../../../types/lists/newsletter-types';

export function useListNewsletterTypes(
  options?: UseQueryOptions<NewsletterTypesResult>
) {
  const api = useNewsletterTypesApi();
  const { data = { results: [] }, ...response } = useGetApi({
    queryKey: newsletterTypesApiKeys.list(),
    request: () => api.list(),
    ...options,
  });

  return {
    ...response,
    newsletterTypeOptions: sortBy(
      data.results.map((option) => ({
        label: option.name,
        value: option.externalId,
        id: option.id,
      })),
      (option) => option.label
    ),
    newsletterTypes: data,
  };
}
